<template>
<section class="rotate-your-phone alert-box">
    <img src="./rotate.svg" alt="Переверніть ваш телефон у альбомний режим">
    <p>Будь ласка, переверніть телефон у альбомний режим для того щоб переглянути візуалізацію</p> 
</section>
</template>

<script>
export default {
    name: "rotate-your-phone",    
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/base/variables';

.rotate-your-phone {
    // display: none;

   img {
        width: 100%;
        max-width: 300px;
        display: block;
        margin: 30px auto;
    }
}

@media screen and (max-width: $sz-mobile){
    .rotate-your-phone {
        display: block;
    }

}

</style>
